import { FetchResult, NormalizedCacheObject } from 'apollo-boost';
import { DocumentNode } from 'graphql';

import { RUM, RumCountersDictKeys } from '../../service/RUM/RUM';
import { QueryAdditionalData } from '../../typings/common';
import { DNAApolloClient } from '../DNAApolloClient/DNAApolloClient';

export abstract class BaseMutationExecutor {
    constructor(protected client: DNAApolloClient<NormalizedCacheObject>) {}

    protected execute<T extends QueryAdditionalData>(
        mutation: DocumentNode,
        input: object,
        additionalOptions: {
            notPoliteMutation?: boolean;
        } = {},
        key: RumCountersDictKeys
    ): Promise<T> {
        const runMutation = () =>
            this.client
                .mutate<T>({
                    mutation,
                    variables: {
                        input,
                        additionalOptions
                    }
                })
                .then((result: FetchResult) => {
                    const data = result.data as T;

                    return {
                        result: data,
                        reqId: data.reqId
                    };
                });

        return RUM.reportAsyncDelta(key, runMutation);
    }

    protected awaitExecute<T extends QueryAdditionalData>(
        mutation: DocumentNode,
        input: object,
        login: string,
        additionalOptions: {
            notPoliteMutation?: boolean;
        } = {},
        key: RumCountersDictKeys,
        additionalInput?: object
    ): Promise<T> {
        const runMutation = () =>
            this.client
                .awaitMutate<T>({
                    mutation,
                    variables: {
                        input,
                        login,
                        additionalOptions,
                        ...additionalInput
                    },
                    login
                })
                .then((result: FetchResult) => {
                    const data = result.data as T;

                    return {
                        result: data,
                        reqId: data.reqId
                    };
                });

        return RUM.reportAsyncDelta(key, runMutation);
    }
}
